import { gql } from "@apollo/client";
import { TransactionDetail, transactionDetailFragment } from "common/graphql/fragments/transactionDetailFragment";
import { parkFragment, Park } from "common/graphql/fragments/parkFragment";
import citationSummaryFragment, { CitationSummary } from "common/graphql/fragments/citation/citationSummaryFragment";

export const citationDetailFragment = gql`
  fragment citationDetailFragment on enforcement_citation {
    ...citationSummaryFragment
    sentToCollectionsAt: sent_to_collections_at
    sessionTransaction: session_transaction {
      ...transactionDetailFragment
    }
    dispute {
      status
    }
    park {
      ...parkFragment
    }
    isSessionTransactionBillable: is_session_transaction_billable
    noticeContentUrl: notice_content_url
    noticeIntegrationPartner: notice_integration_partner {
      isVoidSubmittedNoticeAllowed: is_void_submitted_notice_allowed
      isApplyPaymentToNoticeAllowed: is_apply_payment_to_notice_allowed
    }
  }
  ${citationSummaryFragment}
  ${transactionDetailFragment}
  ${parkFragment}
`;

export interface CitationDetail extends Omit<CitationSummary, "sessionTransaction"> {
  sentToCollectionsAt?: string;
  sessionTransaction: TransactionDetail;
  park?: Park;
  isSessionTransactionBillable: boolean;
  noticeContentUrl?: string;
  noticeIntegrationPartner?: {
    isVoidSubmittedNoticeAllowed: boolean;
    isApplyPaymentToNoticeAllowed: boolean;
  };
}

export default citationDetailFragment;
